import { createSlice } from "@reduxjs/toolkit";
const initialState= {
  language: 'en',
  globalSetting: null,
  showAuthModal: false,
  authModalContent: {
    icon: '',
    title: '',
    message: '',
    btnText: ''
  },
  shouldTimerStart: false,
  showAuthErrorModal: false,
  authErrorModalContent: {
    message: '',
  },
  showEnableMediumAuthBtn: false,
  showGetKuwaitAppBtn: false,
  clicked2FAData: null,
  isPaciLogin: false,
  paciErrorflag: false,
  civilID: "",
  toastData:{
    show: false,
    message: '',
    isIcon: false
  },
  toastDataCustom:{
    show: false,
    icon: '',
    title: '',
    message: '',
  },
  refetchHomePage: false,
  showNotificationAndProfile: false,
}
export const utiltiySlice = createSlice({
  name: "utiltiyData",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setGlobalSetting: (state, action) => {
      state.globalSetting = action.payload;
    },
    setShowAuthModal: (state, action) => {
      state.showAuthModal = action.payload;
    },
    setAuthModalContent: (state, action) => {
      state.authModalContent = action.payload;
    },
    setShouldTimerStart: (state, action) => {
      state.shouldTimerStart = action.payload;
    },
    setShowAuthErrorModal: (state, action) => {
      state.showAuthErrorModal = action.payload;
    },
    setAuthErrorModalContent: (state, action) => {
      state.authErrorModalContent = action.payload;
    },
    setShowEnableMediumAuthBtn: (state, action) => {
      state.showEnableMediumAuthBtn = action.payload;
    },
    setShowGetKuwaitAppBtn: (state, action) => {
      state.showGetKuwaitAppBtn = action.payload;
    },
    setClicked2FAData: (state, action) => {
      state.clicked2FAData = action.payload;
    },
    setPaciLogin: (state, action) => {
      state.isPaciLogin = action.payload
    },
    setPaciErrorFlag: (state, action)=>{
      state.paciErrorflag= action.payload
    },
    setCivilID: (state, action) => {
      state.civilID = action.payload
    },
    setToastData: (state, action) => {
      state.toastData.show = action.payload.show;
      state.toastData.message = action.payload.message;
      state.toastData.isIcon = action.payload.isIcon;
    },
    setToastDataCustom: (state, action) => {
      state.toastDataCustom.show = action.payload.show;
      state.toastDataCustom.icon = action.payload.icon;
      state.toastDataCustom.title = action.payload.title;
      state.toastDataCustom.message = action.payload.message;
    },
    setRefetchHomePage: (state, action) => {	
      state.refetchHomePage = action.payload;	
    },
    setShowNotificationAndProfile: (state, action) => {
      state.showNotificationAndProfile = action.payload;
    },
    resetUtilityReduxData:() => initialState,
  },
});

export const {
  setLanguage,
  setShowAuthModal,
  setGlobalSetting,
  setAuthModalContent,
  setShouldTimerStart,
  setShowAuthErrorModal,
  setAuthErrorModalContent,
  setShowEnableMediumAuthBtn,
  setShowGetKuwaitAppBtn,
  setClicked2FAData, 
  setPaciLogin,
  setPaciErrorFlag,
  setCivilID,
  setToastData,
  setRefetchHomePage,
  resetUtilityReduxData,
  setShowNotificationAndProfile,
  setToastDataCustom
} = utiltiySlice.actions;
export default utiltiySlice.reducer;
